import { appParams, categoryParams, normalizeCollectionResponse, normalizeRecordResponse } from 'api';
import { client, computeHeaders } from 'queries';

export const tagQuery = async ({ req, params }) => {
	const formattedParams = { ...appParams, context: ['cache', 'ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({
		url: `/categories/${params.categoryId}`,
		headers,
		params: formattedParams,
	});
	return normalizeRecordResponse(response);
};

export const categoriesQuery = async ({ req, params, query }) => {
	const formattedParams = { ...categoryParams, ...query, context: ['ssr'] };
	const headers = computeHeaders(req);
	const response = await client.apiRequest({ url: `/categories`, headers, params: formattedParams });
	return normalizeCollectionResponse(response);
};
